export default "__VITE_ASSET__CRs3uVqR__"